// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconEye = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M4 12.23C4.813 14.91 8.133 17 12 17s7.187-2.09 8-4.77v-.46C19.187 9.09 15.867 7 12 7s-7.187 2.09-8 4.77zm18-.73C21 7.5 16.5 5 12 5S3 7.5 2 11.5v1c1 4 5.5 6.5 10 6.5s9-2.5 10-6.5z"
    />,
    <path d="M15 12a3 3 0 11-6 0 3 3 0 016 0" />
  );
export default SvgIconEye;
